<template>
  <header-title />
  <el-dialog v-model="isShowResult" width="90%" style="max-width: 900px; max-height: 600px; overflow-y: scroll">
    <el-tabs type="border-card" style="margin-top: 30px; margin-left: 30px" v-model="activeName"
      @tab-change="_changeActive(activeName)">
      <el-tab-pane label="结果信息" name="first">
        <div class="form" v-for="(item, index) in asksInfo" :key="index" style="margin: 30px 0;">
          <div class="askTitle" style="font-size: 20px">
            {{ item.t_name }}
          </div>
          <div class="answerBox" style="display: flex; flex-wrap: wrap">
            <div class="answer" style="flex-basis: 50%" v-for="(item1, index1) in item.optionsInfos" :key="index1">
              {{ item1.option }} {{ item1.content
              }}<span style="color: #409eff">({{ item1.optionCount }})</span>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="参与人信息" name="second">
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column prop="r_name" label="姓名" width="100" />
          <el-table-column prop="r_phone" label="联系方式" width="150" />
          <el-table-column prop="r_time" label="填写时间" width="180" />
      
          <el-table-column  label="性别" >
            <template v-slot="scope">
              <div>{{ scope.row.r_GENDER == 0 ? '男' : '女' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="r_AGE" label="年龄" width="100" />

          <el-table-column label="是否结婚">
            <template v-slot="scope">
              <div>{{ scope.row.r_MARRIED == 0 ? '否' : '是' }}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
  <el-dialog v-model="isShowQuestion" width="90%" style="max-width: 900px" @close="_resetQueryQuestionData">
    <div class="inner-con">
      <span style="font-weight: bold; font-size: 22px; margin-bottom: 30px">{{ queryQuestionData.s_id_str ? '编辑' : '新增'
        }}问卷</span>
      <el-row class="inner-con-row">
        <span class="span">问卷名称</span>
        <el-input v-model="queryQuestionData.s_name" placeholder="请输入问卷名称" class="input"
          style="min-width: 200px; max-width: 300px" />
      </el-row>
      <el-row class="inner-con-row">
        <span class="span">问卷内容</span>
      </el-row>
      <div class="el-column-dis" v-for="(item, index) in queryQuestionData.titleArray" :key="index">
  <el-row class="inner-con-row">
    <span class="span" style="justify-content: flex-end">{{ index + 1 }}</span>
    <el-input v-model="item.t_name" placeholder="请输入题目名称" class="input" style="min-width: 200px; max-width: 300px" />
  
    <el-button type="danger" size="small" style="margin-left: 20px" @click="_deleteTitle(index)">删除题目</el-button>
    <el-button v-if="index === this.queryQuestionData.titleArray.length - 1" type="primary" size="small" style="margin-left: 20px" @click="_addTitle">增加题目</el-button>
    <el-select v-model="item.t_answer" placeholder="请选择正确答案" style="margin-left: 20px; max-width: 150px">
  <el-option v-for="(option, optionIndex) in item.t_options_array" :key="optionIndex" :label="option.label" :value="option.label" />
</el-select>
  </el-row>
  <el-row class="inner-con-row" v-for="(itemChild, indexChild) in item.t_options_array" :key="indexChild">
    <span class="span" style="justify-content: flex-end; margin-left: 20px">{{ itemChild.label }}</span>
    <el-input v-model="itemChild.value" placeholder="请输入选项名称" class="input" style="min-width: 200px; max-width: 300px" />
    <el-button type="danger" size="small" style="margin-left: 20px" @click="_deleteOptions(index, indexChild)">删除选项</el-button>
    <el-button v-if="indexChild === this.queryQuestionData.titleArray[index].t_options_array.length - 1" type="primary" size="small" style="margin-left: 20px" @click="_addOptions(index)">增加选项</el-button>
  </el-row>
</div>
      <div style="height: 20px" />
    </div>

    <div style="height: 20px" />
    <el-row style="
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
      ">
      <el-button type="danger" style="width: 120px; margin-right: 30px" class="margin-space"
        @click="_showOrHideQuestionDetail">关闭
      </el-button>
      <el-button type="primary" style="width: 120px; margin-right: 5px" class="margin-space" @click="_saveQuestion">保存
      </el-button>
    </el-row>
  </el-dialog>
  <div class="container">
    <aside-body />
    <div class="main" style="margin-left: 30px; margin-top: 30px">
      <el-col :span="24">
        <!-- <el-input v-model="queryData.search" placeholder="请输入要查找的问题" class="input-side" /> -->
        <!-- <el-button type="primary" round @click="_searchPage()">搜索</el-button> -->
        <el-button type="warning" round @click="_editPage(undefined)">新增问卷</el-button>
      </el-col>
      <el-table :data="asks" stripe style="width: 100%" scrollbar-always-on>
        <el-table-column prop="s_name" label="问卷名称" width="240" />
        <el-table-column prop="s_creation_time" label="发布日期" width="230" />
        <el-table-column fixed="right" label="操作" width="320">
          <template v-slot="scope">
            <el-button @click="_editPage(scope.row.s_id_str)" round type="primary">编辑</el-button>
            <el-button @click="_resultPage(scope.row.s_id_str)" round type="success">查看调查结果</el-button>
            <el-button round type="danger" @click="_deleteAnswer(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :page-size="10" layout="prev, pager, next" :total="total" @change="_pageChange" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import headerTitle from '@/components/headerTitle.vue'
import asideBody from '@/components/asideBody.vue'
import {
  getSurvery,
  updateSurvey,
  surveyByID,
  updateSurveyByID,
  getSurveyUserInfo,
  getSelections
} from '@/api/survey'
import { ElMessageBox } from 'element-plus'
import http from '@/util/http'

export default {
  name: 'questionView',
  components: { asideBody, headerTitle },
  data() {
    return {
      asks: [], //问卷列表
      activeName: 'first',
      tableData: [], //参与人信息
      asksInfo: [], //选项信息
      userId: '',
      pageNum: 1,
      total: 0,
      queryQuestionData: {
        s_creation_time: undefined,
        s_delete_flag: 0,
        s_id: null,
        s_id_str: null,
        s_name: null,
        s_updated_time: null,
        title: null,
        titleArray: []
      }, //新增、修改问卷信息
      isShowQuestion: false,
      isShowResult: false
    }
  },
  mounted() {
    this._pageChange(1)
  },
  methods: {
    _showOrHideQuestionDetail() {
      this.isShowQuestion = !this.isShowQuestion
    },
    _showOrHideResult() {
      this.isShowResult = !this.isShowResult
    },
    // 提交、修改问卷
    _resetQueryQuestionData() {
      this.queryQuestionData = {
        s_creation_time: undefined,
        s_delete_flag: 0,
        s_id: null,
        s_id_str: null,
        s_name: null,
        s_updated_time: null,
        title: null,
        titleArray: []
      }
    },
    _pageChange(e) {
      this.pageNum = e
      this._getAskList()
    },
    // 获取问卷列表
    _getAskList() {
      getSurvery({ pageSize: 10, pageNum: this.pageNum }).then(res => {
        if (res.code == 200) {
          this.asks = res.data.list
          this.total = res.data.total
          // console.log(this.asks)
        }
      })
    },
    // 删除问卷
    _deleteAnswer(e) {
      const s_id = e.s_id_str
      ElMessageBox.confirm('确定要删除当前问卷？', '注意', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateSurveyByID({
          s_id: s_id
        }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.description)
            for (const i in this.asks) {
              if (this.asks[i].s_id_str === s_id) {
                this.asks.splice(i, 1)
                break
              }
            }
            this._getAskList()
          } else {
            this.$message.error(res.description)
          }
        })
      })
    },
    _deleteTitle(index) {
      this.queryQuestionData.titleArray.splice(index, 1)
    },
    _deleteOptions(index, indexChild) {
      this.queryQuestionData.titleArray[index].t_options_array.splice(
        indexChild,
        1
      )
      for (const i in this.queryQuestionData.titleArray[index]
        .t_options_array) {
        this.queryQuestionData.titleArray[index].t_options_array[i].label =
          String.fromCharCode(65 + parseInt(i))
      }
    },
    _addOptions(index) {
      this.queryQuestionData.titleArray[index].t_options_array.push({
        label: String.fromCharCode(
          65 +
          parseInt(
            this.queryQuestionData.titleArray[index].t_options_array.length
          )
        ),
        value: undefined
      })
    },
    _saveQuestion() {
  const queryDataInner = {
    survey: {
      s_id: this.queryQuestionData.s_id_str,
      s_name: this.queryQuestionData.s_name
    },
    titles: []
  }
  for (const i in this.queryQuestionData.titleArray) {
    const options = {}
    for (const ii in this.queryQuestionData.titleArray[i].t_options_array) {
      const dataInner = this.queryQuestionData.titleArray[i].t_options_array[ii]
      Object.defineProperty(options, dataInner.label, {
        value: dataInner.value,
        enumerable: true, // 可枚举
        configurable: false, // 不可配置
        writable: true // 可写
      })
    }
    queryDataInner.titles.push({
      t_type: 0,
      t_name: this.queryQuestionData.titleArray[i].t_name,
      t_options: options,
      t_answer: this.queryQuestionData.titleArray[i].t_answer // 添加正确答案字段
    })
  }

  for (let index = 0; index < queryDataInner.titles.length; index++) {
    const options = queryDataInner.titles[index].t_options;
    if (Object.keys(options).length === 0) {
      this.$message.error('请输入选项');
      return;
    }
  }

  updateSurvey(queryDataInner).then(res => {
    if (res.code === 200) {
      this.$message.success(res.description)
      this._showOrHideQuestionDetail()
      this._getAskList()
    } else {
      this.$message.error(res.description)
    }
  })
},
    _addTitle() {
      this.queryQuestionData.titleArray.push({
        s_id: undefined,
        s_id_str: undefined,
        t_id: undefined,
        t_id_str: undefined,
        t_name: undefined,
        t_options: undefined,
        t_options_array: [
          {
            label: 'A',
            value: undefined
          }
        ],
        t_type: 0,
         t_answer: undefined
      })
    },
    // 编辑或新增弹窗
    _editPage(e) {
  this._showOrHideQuestionDetail()
  if (e) {
    surveyByID({ s_id_str: e }).then(res => {
      for (const i in res.data.titleArray) {
        const tOptions = JSON.parse(res.data.titleArray[i].t_options)
        const resultOptions = []
        for (const ii in tOptions) {
          resultOptions.push({
            label: ii,
            value: tOptions[ii]
          })
        }
        res.data.titleArray[i].t_options_array = resultOptions
        // 确保正确答案被设置
        res.data.titleArray[i].t_answer = res.data.titleArray[i].t_answer || ''
      }
      this.queryQuestionData = res.data
    })
  } else {
    this._addTitle()
  }
},
    _resultPage(e) {
      this._showOrHideResult()
      this.userId = e
    
      this.activeName = 'first'
      this._changeActive(this.activeName)
      // getSelections(this.userId).then(res => {
      //   console.log(res)
      //   this.asksInfo = res.data
      // })
    },
    _changeActive(e) {
      console.log(e)
      if (e == 'first') {
        this.asksInfo = []
        getSelections(this.userId).then(res => {
          console.log(res)
          this.asksInfo = res.data
        })
      } else {
        this.tableData = []
        getSurveyUserInfo({ s_id_str: this.userId }).then(res => {
          if (res.code == 200) {
            this.tableData = res.data
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.inner-con {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-height: 600px;
  overflow-y: scroll;
}

.inner-con-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin: 10px 0;
}

.inner-con-row .span {
  margin-right: 10px;
  width: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
}

.el-column-dis {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin: 10px 0;
}
</style>
